<script>
    export let background;

    import { getURL } from '../utils/functions'

    const isImage = background.mime.includes('image') ? true : false
    const isVideo = background.mime.includes('video') ? true : false
    const url = background.url;
    const type = background.mime;
</script>

<div class="hh-cover page-cover">

    {#if isImage}
    <div class="cover-bg pos-abs full-size bg-img  bg-blur-0" data-image-src={getURL(url)}></div>
    {:else if isVideo}
    <div id="container" class="video-container show-for-medium-up">
        <div class="video-overlay"></div>
        <video autoplay="autoplay" loop="loop" muted="muted" preload="auto">
            <source src={getURL(url)} type={type}>
        </video>
    </div>
    {/if}

    <div class="cover-bg-mask pos-abs full-size bg-color" data-bgcolor="rgba(32, 32, 32, 0.2)"></div>

</div>